// extracted by mini-css-extract-plugin
export default {"header":"header_header__MhatS","rounded":"header_rounded__3u7W7","colored":"header_colored__jE5iz"};